import { Injectable } from '@angular/core';
import { Settings } from '../../models';

@Injectable({
  providedIn: 'root',
})
export class SettingsService {
  clientId: number;
  public SETTINGS_KEY: string = 'mqasettings';
  settings: Settings;

  load = (clientId: number) => {
    const value = localStorage.getItem(this.SETTINGS_KEY);
    if (value && value !== '{}') {
      const settings: Settings = JSON.parse(value);
      const defaults = new Settings(clientId);
      if (settings.selectedClientId === clientId) {
        this.settings = settings;
        return this.mergeDefaults(defaults);
      }
    }
    this.settings = { ...new Settings(clientId) };
    this.save();
  };

  merge = (settings: any) => {
    // eslint-disable-next-line guard-for-in
    for (const k in settings) {
      this.settings[k] = settings[k];
    }
    return this.save();
  };

  setValue = (clientId: number, key: string, value: any) => {
    if (!this.settings) {
      this.load(clientId);
    }
    this.settings[key] = value;
    this.save();
  };

  clearValues = (clientId: number) => {
    this.settings = new Settings(clientId);
    this.save();
  };

  getValue = (clientId: number, key: string) => {
    if (!this.settings) {
      this.load(clientId);
    }
    return this.settings[<any>key];
  };

  getStoredValue = (key: string) => {
    const value = localStorage.getItem(this.SETTINGS_KEY);
    if (value) {
      const settings: Settings = JSON.parse(value);
      return settings[<keyof Settings>key];
    }
    return null;
  };

  setStoredValue(key: string, propValue: any): void {
    const newSetting = { [key]: propValue };
    const value: any = localStorage.getItem(this.SETTINGS_KEY);
    let settings: Settings = JSON.parse(value) || {};
    settings = Object.assign(settings, newSetting);
    localStorage.setItem(this.SETTINGS_KEY, JSON.stringify(settings));
  }

  save = (settings: Settings | null = null) => {
    if (settings) {
      this.settings = { ...settings };
    }
    localStorage.setItem(
      this.SETTINGS_KEY,
      JSON.stringify({ ...this.settings })
    );
  };

  getAllSettings = (clientId: number) => {
    if (!this.settings) {
      this.load(clientId);
    }
    return this.settings;
  };

  public mergeDefaults = (defaults: Settings) => {
    for (const k in defaults) {
      if (!(k in this.settings)) {
        this.settings[k] = defaults[k];
      }
    }

    return this.save();
  };
}
